import i18next from 'i18next';
import * as yup from 'yup';

export const zipCodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;

export const getZipCodeSchema = (): yup.StringSchema =>
  yup.string().matches(zipCodeRegex, { message: i18next.t('validation.error.zipCode'), excludeEmptyString: true });
